import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {OwnCatalogItemView} from "./OwnCatalogItemView";
import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {ownCatalogItemModel, emptyOwnCatalogItemModel} from "./ownCatalogItemFactory";
import {locations} from "../../../../Utilities/Location";
import {ownCatalogItemApi} from "./ownCatalogItemApi";
import {SYSTEM_TYPES} from "../../libraryConstants";
import {getSystemTypeTextByValue} from "../../libraryUtility";
import {LinkButton} from "../../../../Components/Link";
import {allow} from "../../../../Components/Authorize";
import * as PolicyEvents from "../../../../Components/Authorize/policyEventsConstants";
import {libraryCatalogApi} from "../../libraryCatalogApi";
import {createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";

export const OwnCatalogItemContainer = ({
                                         handleApiCall,
                                         catalogItemId,
                                         redirect,
                                         systemType,
                                     }: ContextProps) => {

    const [ownCatalogItem, setOwnCatalogItem] = useState<Record<string, unknown>>();
    const isEdit = catalogItemId && catalogItemId !== emptyGuid;
    const canManageOwnCatalogItems = allow(PolicyEvents.MANAGE_OWN_CATALOG_ITEMS);

    const [vendors, setVendors] = useState<Record<string, unknown>[]>();
    const [manufacturers, setManufacturers] = useState<Record<string, unknown>[]>();
    const vendorList = createListFromArrayOfObjects(vendors, "vendorId", "name");
    const manufacturerList = createListFromArrayOfObjects(manufacturers, "manufacturerId", "name");

    const handleReturn = () => {
        const selectedSystemType = systemType || ownCatalogItem?.systemType;
        redirect(locations.OWN_CATALOG.getLink(selectedSystemType).to)
    };

    const handleSaveOwnCatalogItem = async (ownCatalogItemModel: Record<string, unknown>) => {
        if(isEdit)
             return handleApiCall(() => ownCatalogItemApi.UpdateOwnCatalogItem(ownCatalogItemModel), handleReturn);
        else
            return handleApiCall(() => ownCatalogItemApi.AddOwnCatalogItem(ownCatalogItemModel), handleReturn);
    };

    const loadOwnCatalogItemResult = (result: Record<string, unknown>) => {
        const ownCatalogItem = ownCatalogItemModel(result);
        setOwnCatalogItem(ownCatalogItem);
    };

    useEffect(() => {

        const newOwnCatalogItem = {
            ...emptyOwnCatalogItemModel,
            systemType
        }
        const getOwnCatalogItem = () => {
            handleApiCall(() => ownCatalogItemApi.GetOwnCatalogItemById(catalogItemId), (results = newOwnCatalogItem) => loadOwnCatalogItemResult(results));
        }

        const getVendors = () => {
            handleApiCall(() => libraryCatalogApi.getVendorsAll(), (results: Record<string, unknown>[]) => setVendors(results));
        };

        const getManufacturers = () => {
            handleApiCall(() => libraryCatalogApi.getManufacturers(), (results: Record<string, unknown>[]) => setManufacturers(results));
        };

        if (isEdit && !ownCatalogItem)
            getOwnCatalogItem();
        else
            setOwnCatalogItem(newOwnCatalogItem);

        if (!vendors)
            getVendors();
        if (!manufacturers)
            getManufacturers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catalogItemId]);

    if (!ownCatalogItem) return <></>;

    return <>
        <PageTitle h1={`${getSystemTypeTextByValue(SYSTEM_TYPES.Own.toString())} Catalog Item`}/>
        {isEdit && canManageOwnCatalogItems &&
            <LinkButton
                {...locations.OWN_CATALOG_ITEM.getLink([emptyGuid, systemType])}
                label="Add New Item"
            />
        }
        <OwnCatalogItemView
            handleSaveOwnCatalogItem={handleSaveOwnCatalogItem}
            handleReturn={handleReturn}
            ownCatalogItem={ownCatalogItem}
            manufacturerList={manufacturerList}
            vendorList={vendorList}
        />
    </>;
};
